import React, { useState } from "react";
import { MessageSquare, ArrowRight, Mail } from "lucide-react";
import { Loader2 } from "lucide-react";
import emailjs from "emailjs-com";
import toast from "react-hot-toast";

export default function ContactComponent() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const SERVICE_ID = process.env.REACT_APP_SERVICE_ID;
  const TEMPLATE_ID = process.env.REACT_APP_TEMPLATE_ID;
  const USER_ID = process.env.REACT_APP_USER_ID;
  const AUTO_REPLY_TEMPLATE_ID = process.env.REACT_APP_AUTO_REPLY_TEMPLATE_ID;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setStatus("Please enter your email");
      return;
    }
    setIsSubmitting(true);

    const formData = {
      from_name: "Your Hardcoded Name",
      reply_to: email,
      message: e.target.elements.message?.value || "No message provided",
    };

    toast
      .promise(
        emailjs.send(SERVICE_ID, TEMPLATE_ID, formData, USER_ID).then(
          (response) => {
            return emailjs.send(
              SERVICE_ID,
              AUTO_REPLY_TEMPLATE_ID,
              {
                from_name: "Your Hardcoded Name",
                reply_to: email,
              },
              USER_ID
            );
          },
          (err) => {
            throw new Error("Failed to send message.");
          }
        ),
        {
          loading: "Sending...",
          success: "Message sent successfully!",
          error: "Failed to send message",
        }
      )
      .then(() => {
        setIsSubmitting(false);
        setEmail("");
        if (e.target.elements.message) {
          e.target.elements.message.value = "";
        }
      })
      .catch(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="px-4 md:px-0" id="contact">
      <div className="rounded-xl p-6 sm:p-8 my-6 w-full max-w-2xl mx-auto bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 shadow-lg transition-all duration-300">
      <h5 className="text-xl sm:text-2xl font-bold text-indigo-700 dark:text-indigo-300 mb-2">Let's Connect!</h5>
      <p className="mb-5 text-zinc-600 dark:text-zinc-300 text-base sm:text-lg">Interested in working together? Drop your email and let's chat!</p>

      {/* WhatsApp Button */}
      <div className="mb-5">
        <a
          href="https://wa.me/7378360027?text=I want to work on a project with you"
          className="w-full sm:max-w-xs text-center py-2 px-4 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-50 flex items-center justify-center shadow"
        >
          <MessageSquare className="mr-2 h-5 w-5" />
          Chat on WhatsApp
          <ArrowRight className="ml-2 h-5 w-5" />
        </a>
      </div>
      <div className="border-t border-zinc-200 dark:border-zinc-700 w-full my-5"></div>
      {/* Email Form */}
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col sm:flex-row gap-3 mb-4">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="flex-grow px-3 py-2 rounded-lg border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800 text-zinc-900 dark:text-zinc-100 focus:outline-none focus:ring-2 focus:ring-indigo-400 text-base"
          />
        </div>
        <textarea
          name="message"
          placeholder="Your Message"
          className="w-full h-20 resize-none px-3 py-2 mb-4 rounded-lg border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800 text-zinc-900 dark:text-zinc-100 focus:outline-none focus:ring-2 focus:ring-indigo-400 text-base"
        />

        <button
          type="submit"
          className="w-full sm:w-auto px-6 py-2 rounded-xl bg-indigo-600 text-white dark:bg-indigo-500 dark:text-zinc-100 font-semibold shadow-md hover:bg-indigo-700 dark:hover:bg-indigo-600 transition focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-opacity-50 flex items-center justify-center text-base"
        >
          {isSubmitting ? (
            <Loader2 className="w-5 h-5 animate-spin" />
          ) : (
            <>
              <Mail className="mr-2 h-5 w-5" />
              Connect
            </>
          )}
        </button>
        {status && (
          <p className="mt-3 text-base text-red-600 dark:text-red-400">
            {status}
          </p>
        )}
      </form>
    </div>
    </div>
  );
}
